import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class SmoothScroll {
	constructor() {
		if (SmoothScroll.instance) return SmoothScroll.instance

		this._lenis = null
		this.options = {}
		this.#init()

		SmoothScroll.instance = this
	}

	#init() {
		this.#registerScrollTrigger()
		this.#scrollToHashOnLoad()

		// Lenis causes scroll jitter in Safari, fall back to native scrolling
		if (SmoothScroll.isSafari()) return

		this.#initLenis()
		this.#addGsapTicker()
	}

	#scrollToHashOnLoad() {
		window.addEventListener('load', () => {
			const hash = window.location.hash
			if (!hash) return

			const target = document.querySelector(hash)
			if (!target) return

			this.scrollTo(target, {
				offset: -80,
				duration: 2.5,
				immediate: true,
			})
		})
	}

	static isSafari() {
		const ua = navigator.userAgent
		return /Safari/.test(ua) && !/Chrome|Chromium|Android|CriOS|FxiOS|Edg/.test(ua)
	}

	#initLenis() {
		this.options = { allowNestedScroll: true }
		this._lenis = new Lenis(this.options)
	}

	#addGsapTicker() {
		this._lenis.on('scroll', ScrollTrigger.update)
		gsap.ticker.add(time => {
			this._lenis.raf(time * 1000)
		})
		gsap.ticker.lagSmoothing(0)
	}

	#registerScrollTrigger() {
		gsap.registerPlugin(ScrollTrigger)
	}

	scrollTo(target, options = {}) {
		if (this._lenis) {
			this._lenis.scrollTo(target, options)
			return
		}

		const element = typeof target === 'string' ? document.querySelector(target) : target
		if (!element) return

		const offset = options.offset ?? 0
		window.scrollTo({
			top: element.getBoundingClientRect().top + window.scrollY + offset,
			behavior: options.immediate ? 'auto' : 'smooth',
		})
	}

	get lenis() {
		return this._lenis
	}
}
